/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull starship'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 6
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/implementation/starship)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: '11f1e79f7853b0181aaa6f2a08d1f386',
  development: '83c4d435d2680d01341ddd2abfd0d50e'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '6',
    branch: 'main',
    source: 'starship',
    versionId: 'bca309c9-af23-458f-b81d-d1ac4f9736d7'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  attribution?: any;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_ad_group_id?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_ad_id?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_campaign_id?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_category?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_criteria_id?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_gclid?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_network?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_placement?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_placement_category?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_searchtype?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_type?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_utm_campaign?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_utm_content?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_utm_medium?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_utm_source?: string;
  /**
   * Is wiped along with all attribution\_ params whenever any attribution parameter is detected on a user (such as UTMs, gclids, searchtype params etc)
   */
  attribution_utm_term?: string;
  category?: any;
  /**
   * User property.
   *
   * Status for the newsletter consent of the user.
   * - True = consent to get newsletter emails
   * - False = removed consent
   * - None = never given consent
   *
   * Sent from our email management system (EMS).
   */
  consent_trendhim_ecom_email_newsletter?: any;
  consent_trendhim_ecom_phone_call_research?: any;
  consent_trendhim_ecom_sms_commercial?: any;
  filter_clockworks?: any;
  filter_computer_sizes?: any;
  filter_primary_colors?: any;
  filter_primary_materials?: any;
  filter_strap_materials?: any;
  first_name?: any;
  forward_trendhim_ecom_customer_io?: any;
  /**
   * User property.
   *
   * Google Click Identifier. Added to all Google ads.
   *
   * Google Analytics converts this into source/medium information - not possible in Amplitude.
   */
  gclid?: any;
  gender_derived?: any;
  jf_test?: any;
  last_name?: any;
  nps_answered?: any;
  nps_latest_category?: any;
  nps_latest_score?: any;
  phone_number?: any;
  products_viewed?: any;
  products_viewed_unix?: any;
  q?: any;
  quote_id?: any;
  /**
   * User property.
   *
   * Based on document.referrer
   */
  referrer?: any;
  /**
   * User property.
   *
   * Based on document.referrer
   */
  referring_domain?: any;
  /**
   * User property.
   *
   * Custom function in cloud service to group referring domains if they contain a defined term.
   */
  referring_domain_grouped?: any;
  searchtype?: any;
  th_filter_farve?: any;
  th_filter_materiale?: any;
  th_filter_oereringe_zirkon?: any;
  th_filter_slips_model?: any;
  th_filter_ure_rem_materiale?: any;
  title?: any;
  /**
   * User property.
   *
   * Local Trendhim contact email.
   * Sent from our email management system (EMS).
   */
  trendhim_ecom_newsletter_local_email?: any;
  /**
   * User property.
   *
   * Country of recipient.
   * Sent from our email management system (EMS).
   */
  trendhim_ecom_newsletter_locale?: any;
  /**
   * User property.
   *
   * A combination of the 2 attributes: 'source_id' & 'campaign_label'.
   * Sent from our email management system (EMS).
   */
  trendhim_ecom_newsletter_source?: any;
  trendhim_ecom_phone_call_research_locale?: any;
  trendhim_ecom_sms_commercial_source?: any;
  trendhim_ecom_split_tests?: any;
  /**
   * User property.
   */
  utm_campaign?: any;
  /**
   * User property.
   */
  utm_content?: any;
  /**
   * User property.
   */
  utm_medium?: any;
  /**
   * User property.
   */
  utm_source?: any;
  /**
   * User property.
   */
  utm_term?: any;
  web_os_name?: any;
  web_os_version?: any;
}

export interface AmplitudePageViewedProperties {
  "[Amplitude] Page Domain"?: string;
  "[Amplitude] Page Location"?: string;
  "[Amplitude] Page Path"?: string;
  "[Amplitude] Page Title"?: string;
  "[Amplitude] Page URL"?: string;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  fbclid?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  gbraid?: string;
  gclid?: any;
  guide_info_link_type?: any;
  has_bundled_expandable_list?: any;
  has_bundled_products?: any;
  has_cross_sale_expandable_list?: any;
  has_cross_sale_products?: any;
  has_guide_info_link?: any;
  has_linked_products?: any;
  has_personalisation?: any;
  has_reviews?: any;
  has_sizes?: any;
  has_translated_reviews?: any;
  has_video?: any;
  has_view_more_reviews?: any;
  is_cod_available?: any;
  is_droppoint_available?: any;
  is_landing_page?: any;
  is_on_sale?: any;
  is_saleable?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  msclkid?: string;
  query_parameters?: any;
  referrer?: any;
  referring_domain?: any;
  referring_domain_grouped?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  ttclid?: string;
  utm_campaign?: any;
  utm_content?: any;
  utm_medium?: any;
  utm_source?: any;
  utm_term?: any;
}

export interface BackInStockSubscribeProperties {
  m_particle_source_feed?: any;
  product_id?: any;
}

export interface CaAccCreateResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  newsletter_opt_in?: any;
  reason?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CaLoginResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  location?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface CaLogoutResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CaMyDetailsUpdateProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  field_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CaPwdCreateResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CaPwdResetResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  location?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface CaPwdUpdateResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CartAddClickProperties {
  /**
   * How much content has been seen as a percentage. For pages that fully fit the screen, it'll stay at 100. When the content takes up twice the screen height, it'll start at 50 in the top of the page, and 100 in the bottom.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  content_percentage?: number;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  /**
   * Tracked elements that are currently at least 10% visible in the view port.
   *  See history of visible elements in the in*view*history attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view?: string[];
  /**
   * Tracked elements that have been at least 10% visible in the view port.
   *  See currently visible elements in the in_view attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view_history?: string[];
  query_parameters?: any;
  quote_id?: any;
  /**
   * Parent products are the "parent" products available in the cart at the time of the event.
   */
  recoverable_cart_products?: any[];
  /**
   * Scroll position as a percentage. 0 means top of page, 100 means bottom of page.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  scroll_percentage?: number;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_block_id?: string;
  src_block_type?: string;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface CartAddFailedProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface CartPersonalisationAddClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CartPersonalisationUpdateClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CartPersonalisationUpdatedProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_added?: any;
  is_removed?: any;
  is_success?: any;
  is_updated?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CartQtyChangeProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_quantity_increased?: any;
  product_id?: any;
  query_parameters?: any;
  /**
   * Parent products are the "parent" products available in the cart at the time of the event.
   */
  recoverable_cart_products?: any[];
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  variant_id?: string;
  was_buttons_used?: any;
}

export interface CartRemoveResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  product_id?: any;
  query_parameters?: any;
  /**
   * Parent products are the "parent" products available in the cart at the time of the event.
   */
  recoverable_cart_products?: any[];
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  variant_id?: string;
}

export interface CmsLeadMagnetOptInProperties {
  campaign_label?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface CmsNotifyMeOptInProperties {
  campaign_label?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface CofAddressFilledFromEmailProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofCodDeliveryMethodSelectProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofCompletionAttemptProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  has_had_payment_error?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofCompletionFailResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  payment_method?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofDeliveryMethodInfoOverlayOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofDeliveryOptionSelectProperties {
  country?: any;
  delivery_option_key?: any;
  delivery_option_legacy_key?: any;
  device_browser_width?: any;
  device_type?: any;
  selected_country?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofDroppointAutoFindResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofDroppointDeliveryMethodSelectProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofDroppointOverlayOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface CofPaymentOptionSelectProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  payment_option_id?: any;
  payment_option_sub_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ContactEmailSentResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface DataImportProperties {
  m_particle_source_feed?: any;
}

export interface DeliveryDetailsOverlayOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ECommerceAddToCartItemProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  applied_tactic_percentage?: number;
  applied_tactic_type?: string;
  attribute_sub_type?: string;
  attribute_type?: string;
  brand?: any;
  Brand?: any;
  categories?: any;
  category_ids?: any;
  category_main?: any;
  category_sub?: any;
  /**
   * How much content has been seen as a percentage. For pages that fully fit the screen, it'll stay at 100. When the content takes up twice the screen height, it'll start at 50 in the top of the page, and 100 in the bottom.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  content_percentage?: number;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  has_personalised_products?: any;
  has_video?: any;
  id?: any;
  Id?: any;
  /**
   * Tracked elements that are currently at least 10% visible in the view port.
   *  See history of visible elements in the in*view*history attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view?: string[];
  /**
   * Tracked elements that have been at least 10% visible in the view port.
   *  See currently visible elements in the in_view attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view_history?: string[];
  is_cross_sale_product_added?: any;
  is_high_cross_sale_available?: any;
  is_new?: any;
  is_on_sale?: any;
  is_personalisation_available?: any;
  local_price?: any;
  local_total_product_amount?: any;
  milestone_id?: string;
  personalisation_type?: any;
  /**
   * **don't trust this - it contains engravings on gift wrapping which is patently wrong.**
   */
  personalisation_types?: any;
  price?: any;
  Price?: any;
  product_id?: any;
  product_type?: string;
  quantity?: any;
  Quantity?: any;
  query_parameters?: any;
  /**
   * Scroll position as a percentage. 0 means top of page, 100 means bottom of page.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  scroll_percentage?: number;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_block_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  src_block_type?: string;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  tactic_add_and_save_product_ids?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  tactic_matching_variant_percentage?: number;
  tactic_matching_variant_product_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | variant, fallback |
   */
  tactic_matching_variant_type?: "variant" | "fallback";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  tactic_relative_discount_product_ids?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | matching_variant, relative_discount, add_and_save |
   */
  tactic_type?: "matching_variant" | "relative_discount" | "add_and_save";
  "Total Product Amount"?: any;
  total_product_amount?: any;
  variant_id?: string;
}

export interface ECommerceAddToWishlistItemProperties {
  brand?: any;
  Brand?: any;
  categories?: any;
  category_ids?: any;
  category_main?: any;
  category_sub?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  has_video?: any;
  id?: any;
  Id?: any;
  is_new?: any;
  is_on_sale?: any;
  local_price?: any;
  name?: any;
  personalisation_type?: any;
  price?: any;
  Price?: any;
  quantity?: any;
  Quantity?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  "Total Product Amount"?: any;
  total_product_amount?: any;
}

export interface ECommerceCheckoutProperties {
  cof_step_no?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_cod_available?: any;
  is_delivery_method_selected?: any;
  is_droppoint_available?: any;
  query_parameters?: any;
  /**
   * Parent products are the "parent" products available in the cart at the time of the event.
   */
  recoverable_cart_products?: any[];
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ECommercePurchaseItemProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  applied_tactic_percentage?: number;
  applied_tactic_type?: string;
  attribute_sub_type?: string;
  attribute_type?: string;
  brand?: any;
  Brand?: any;
  categories?: any;
  category_ids?: any;
  category_main?: any;
  category_sub?: any;
  country?: any;
  customer_order_count?: any;
  device_browser_width?: any;
  device_type?: any;
  has_personalised_products?: any;
  has_video?: any;
  id?: any;
  Id?: any;
  is_new?: any;
  is_on_sale?: any;
  local_price?: any;
  local_total_product_amount?: any;
  milestone_id?: string;
  personalisation_type?: any;
  /**
   * **don't trust this - it contains engravings on gift wrapping which is patently wrong.**
   */
  personalisation_types?: any;
  price?: any;
  Price?: any;
  product_id?: any;
  product_type?: string;
  /**
   * Calculated client side based on profit tracking system.
   */
  profit_amount?: any;
  quantity?: any;
  Quantity?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
  "Total Product Amount"?: any;
  total_product_amount?: any;
  "Transaction Id"?: any;
  transaction_id?: any;
  variant_id?: string;
}

export interface ECommerceRemoveFromWishlistItemProperties {
  brand?: any;
  Brand?: any;
  categories?: any;
  category_ids?: any;
  category_main?: any;
  category_sub?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  has_video?: any;
  id?: any;
  Id?: any;
  is_new?: any;
  is_on_sale?: any;
  local_price?: any;
  name?: any;
  personalisation_type?: any;
  price?: any;
  Price?: any;
  quantity?: any;
  Quantity?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  "Total Product Amount"?: any;
  total_product_amount?: any;
}

export interface EmailBouncedProperties {
  action_id?: any;
  campaign_id?: any;
  customer_id?: any;
  delivery_id?: any;
  failure_message?: any;
  journey_id?: any;
  recipient?: any;
  subject?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  trigger_event_id?: string;
}

export interface EmailClickedProperties {
  action_id?: any;
  campaign_id?: any;
  content_id?: any;
  customer_id?: any;
  delivery_id?: any;
  href?: any;
  journey_id?: any;
  link_id?: any;
  newsletter_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  parent_action_id?: number;
  recipient?: any;
  subject?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  trigger_event_id?: string;
}

export interface EmailConvertedProperties {
  action_id?: any;
  campaign_id?: any;
  customer_id?: any;
  delivery_id?: any;
  journey_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  parent_action_id?: number;
  recipient?: any;
  subject?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  trigger_event_id?: string;
}

export interface EmailDeliveredProperties {
  action_id?: any;
  campaign_id?: any;
  customer_id?: any;
  delivery_id?: any;
  journey_id?: any;
  recipient?: any;
  subject?: any;
}

export interface EmailFailedProperties {
  action_id?: any;
  campaign_id?: any;
  customer_id?: any;
  delivery_id?: any;
  failure_message?: any;
  journey_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  trigger_event_id?: string;
}

export interface EmailLinkClickedProperties {
  action_id?: any;
  campaign_id?: any;
  content_id?: any;
  delivery_id?: any;
  href?: any;
  journey_id?: any;
  link_id?: any;
  m_particle_source_feed?: any;
  newsletter_id?: any;
  recipient?: any;
  subject?: any;
}

export interface EmailOpenedProperties {
  action_id?: any;
  campaign_id?: any;
  content_id?: any;
  customer_id?: any;
  delivery_id?: any;
  journey_id?: any;
  m_particle_source_feed?: any;
  newsletter_id?: any;
  recipient?: any;
  subject?: any;
}

export interface EmailSentProperties {
  action_id?: any;
  campaign_id?: any;
  content_id?: any;
  customer_id?: any;
  delivery_id?: any;
  failure_message?: any;
  journey_id?: any;
  m_particle_source_feed?: any;
  newsletter_id?: any;
  recipient?: any;
  subject?: any;
  trigger_id?: any;
}

export interface EmailUnsubscribedProperties {
  content_id?: any;
  customer_id?: any;
  delivery_id?: any;
  newsletter_id?: any;
  recipient?: any;
  subject?: any;
}

export interface GalleryFullGalleryOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface GalleryFullGalleryZoomInProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface GalleryThumbArrowsClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  direction?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface GoToTopProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface GuidedFiltersClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  guided_filter?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ModalOpenProperties {
  country?: any;
  dest_page_type?: any;
  dest_page_type_id?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NavDesktopMegaMenuOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  menu_index?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NavLinkClickProperties {
  /**
   * How much content has been seen as a percentage. For pages that fully fit the screen, it'll stay at 100. When the content takes up twice the screen height, it'll start at 50 in the top of the page, and 100 in the bottom.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  content_percentage?: number;
  country?: any;
  dest_page_type?: any;
  dest_page_type_id?: any;
  device_browser_width?: any;
  device_type?: any;
  /**
   * Tracked elements that are currently at least 10% visible in the view port.
   *  See history of visible elements in the in*view*history attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view?: string[];
  /**
   * Tracked elements that have been at least 10% visible in the view port.
   *  See currently visible elements in the in_view attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view_history?: string[];
  is_success?: any;
  location?: any;
  query_parameters?: any;
  /**
   * Scroll position as a percentage. 0 means top of page, 100 means bottom of page.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  scroll_percentage?: number;
  search_query?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NavMobileMenuCategoryToggleProperties {
  category_id?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_opened?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NavMobileMenuThemeToggleProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NavMobileMenuToggleProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_opened?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NavSideBarCategoryToggleProperties {
  category_id?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_opened?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NewsletterOptInProperties {
  campaign_label?: any;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  m_particle_source_feed?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface NewsletterOptOutProperties {
  m_particle_source_feed?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
}

export interface PlApplyFilterProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  filter_code?: any;
  filter_option_id?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface PlApplySortingProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  sorting_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface PostPurchaseUpsellAcceptProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  order_number: string;
  product_id?: any;
  profit_base?: any;
  profit_local?: any;
  revenue_base?: any;
  revenue_local?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface PostPurchaseUpsellDeclineProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  product_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface PostPurchaseUpsellShowProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  product_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface PpBundleListToggleProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_opened?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface PpCrossSalesListToggleProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_opened?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface PpDescriptionDesktopOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface PpDetailsMobileToggleProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_opened?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
  type?: any;
}

export interface PpGuideInfoLinkOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface PpHcsPersonalisationAddedProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ProductMissingSizeReportResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_success?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ProductOutOfStockOptInResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_email_added?: any;
  is_phone_number_added?: any;
  is_size_product?: any;
  is_success?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ProductReviewsOpenAllProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ProductReviewsViewMoreProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ProductReviewsViewTranslatedProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface ProductSizeOverlayOpenProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ProductSpecificationsOpenProperties {
  block_id?: string;
  block_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  country?: string;
  device_browser_width?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  device_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  query_parameters?: string;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_block_id?: string;
  src_block_type?: string;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface PromptOpenProperties {
  /**
   * How much content has been seen as a percentage. For pages that fully fit the screen, it'll stay at 100. When the content takes up twice the screen height, it'll start at 50 in the top of the page, and 100 in the bottom.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  content_percentage?: number;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  /**
   * Tracked elements that are currently at least 10% visible in the view port.
   *  See history of visible elements in the in*view*history attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view?: string[];
  /**
   * Tracked elements that have been at least 10% visible in the view port.
   *  See currently visible elements in the in_view attribute.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  in_view_history?: string[];
  query_parameters?: any;
  /**
   * Scroll position as a percentage. 0 means top of page, 100 means bottom of page.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  scroll_percentage?: number;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ReturnAdditionalProductAddClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ReturnAdditionalProductPreviewClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ReturnAdditionalProductRemoveClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ReturnAdditionalProductsSearchStartProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ReturnBrokenEmailSentProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface ReturnBrokenNoticeLinkClickProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ReturnBrokenNoticeShowProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface ReturnComingToStepProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  step_no?: any;
  store_id?: any;
}

export interface ReturnCompletionAttemptProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  has_exchanged_broken?: any;
  has_exchanged_size?: any;
  has_gift_card_nudging?: any;
  has_new_products?: any;
  is_gift_card_selected?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface RevenueAmountProperties {
  $price?: any;
  $productId?: any;
  $quantity?: any;
  $revenue?: any;
  $revenueType?: any;
  affiliation?: any;
  Affiliation?: any;
  category_ids?: any;
  country?: any;
  "Coupon Code"?: any;
  coupon_code?: any;
  customer_order_count?: any;
  device_browser_width?: any;
  device_type?: any;
  has_personalised_products?: any;
  has_video?: any;
  /**
   * **don't trust this - it contains engravings on gift wrapping which is patently wrong.**
   */
  personalisation_types?: any;
  "Product Count"?: any;
  product_count?: any;
  /**
   * Calculated client side based on profit tracking system.
   */
  profit_amount?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
  "Tax Amount"?: any;
  tax_amount?: any;
  total_amount?: any;
  "Transaction Id"?: any;
  transaction_id?: any;
}

export interface SearchStartProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  has_previous_search?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface SessionEndProperties {
  country?: string;
  device_browser_width?: any;
  device_type?: string;
  query_parameters?: string;
  session_uuid?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface SessionStartProperties {
  country?: string;
  device_browser_width?: any;
  device_type?: string;
  query_parameters?: string;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
}

export interface SimpleGalleryFirstSlideProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface SliderChangeSlideProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  direction?: any;
  source_id?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface SmsSentProperties {
  content_id?: any;
  delivery_id?: any;
  m_particle_source_feed?: any;
  newsletter_id?: any;
  recipient?: any;
}

export interface SmsCommercialOptInProperties {
  m_particle_source_feed?: any;
  source_id?: any;
}

export interface SmsCommercialOptOutProperties {
  m_particle_source_feed?: any;
}

export interface SuccessLetsTalkOptInResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface SuccessOrderEmailUpdateProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface SuccessSmsOptInResProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface TimeUsedOnPageProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  perf_web_vitals_fcp?: any;
  perf_web_vitals_fid?: any;
  perf_web_vitals_lcp?: any;
  perf_web_vitals_ttfb?: any;
  query_parameters?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  time_in_seconds?: any;
}

export interface TransactionalOptInProperties {
  m_particle_source_feed?: any;
  source_id?: any;
}

export interface UnverifiedRevenueProperties {
  $price?: any;
  $productId?: any;
  $quantity?: any;
  $revenue?: any;
  $revenueType?: any;
  affiliation?: any;
  Affiliation?: any;
  category_ids?: any;
  country?: any;
  "Coupon Code"?: any;
  coupon_code?: any;
  customer_order_count?: any;
  device_browser_width?: any;
  device_type?: any;
  has_personalised_products?: any;
  has_video?: any;
  /**
   * **don't trust this - it contains engravings on gift wrapping which is patently wrong.**
   */
  personalisation_types?: any;
  "Product Count"?: any;
  product_count?: any;
  /**
   * Calculated client side based on profit tracking system.
   */
  profit_amount?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
  "Tax Amount"?: any;
  tax_amount?: any;
  "Transaction Id"?: any;
  transaction_id?: any;
}

export interface UserInputErrorProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  errors?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export interface VideoStartProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  is_full_gallery?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  store_id?: any;
}

export interface ViewedPageProperties {
  attribute_sub_type?: string;
  attribute_type?: string;
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  fbclid?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  gbraid?: string;
  gclid?: any;
  guide_info_link_type?: any;
  has_bundled_expandable_list?: any;
  has_bundled_products?: any;
  has_cross_sale_expandable_list?: any;
  has_cross_sale_products?: any;
  has_guide_info_link?: any;
  has_linked_products?: any;
  has_normal_header?: any;
  has_personalisation?: any;
  has_reviews?: any;
  has_side_bar?: any;
  has_sizes?: any;
  has_translated_reviews?: any;
  has_video?: any;
  has_view_more_reviews?: any;
  is_cod_available?: any;
  is_droppoint_available?: any;
  is_landing_page?: any;
  is_on_sale?: any;
  is_saleable?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  msclkid?: string;
  product_type?: string;
  query_parameters?: any;
  referrer?: any;
  referring_domain?: any;
  referring_domain_grouped?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  src_page_type_id?: any;
  src_page_type_id_unix?: any;
  store_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  ttclid?: string;
  type?: any;
  utm_campaign?: any;
  utm_content?: any;
  utm_medium?: any;
  utm_source?: any;
  utm_term?: any;
}

export interface WishListClearProperties {
  country?: any;
  device_browser_width?: any;
  device_type?: any;
  source_name?: any;
  source_type?: any;
  split_tests?: any;
  src_page_type?: any;
  store_id?: any;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AmplitudePageViewed implements BaseEvent {
  event_type = '[Amplitude] Page Viewed';

  constructor(
    public event_properties?: AmplitudePageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BackInStockSubscribe implements BaseEvent {
  event_type = 'back_in_stock_subscribe';

  constructor(
    public event_properties?: BackInStockSubscribeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaAccCreateRes implements BaseEvent {
  event_type = 'ca_acc_create_res';

  constructor(
    public event_properties?: CaAccCreateResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaLoginRes implements BaseEvent {
  event_type = 'ca_login_res';

  constructor(
    public event_properties?: CaLoginResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaLogoutRes implements BaseEvent {
  event_type = 'ca_logout_res';

  constructor(
    public event_properties?: CaLogoutResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaMyDetailsUpdate implements BaseEvent {
  event_type = 'ca_my_details_update';

  constructor(
    public event_properties?: CaMyDetailsUpdateProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaPwdCreateRes implements BaseEvent {
  event_type = 'ca_pwd_create_res';

  constructor(
    public event_properties?: CaPwdCreateResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaPwdResetRes implements BaseEvent {
  event_type = 'ca_pwd_reset_res';

  constructor(
    public event_properties?: CaPwdResetResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CaPwdUpdateRes implements BaseEvent {
  event_type = 'ca_pwd_update_res';

  constructor(
    public event_properties?: CaPwdUpdateResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartAddClick implements BaseEvent {
  event_type = 'cart_add_click';

  constructor(
    public event_properties?: CartAddClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartAddFailed implements BaseEvent {
  event_type = 'cart_add_failed';

  constructor(
    public event_properties?: CartAddFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartPersonalisationAddClick implements BaseEvent {
  event_type = 'cart_personalisation_add_click';

  constructor(
    public event_properties?: CartPersonalisationAddClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartPersonalisationUpdateClick implements BaseEvent {
  event_type = 'cart_personalisation_update_click';

  constructor(
    public event_properties?: CartPersonalisationUpdateClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartPersonalisationUpdated implements BaseEvent {
  event_type = 'cart_personalisation_updated';

  constructor(
    public event_properties?: CartPersonalisationUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartQtyChange implements BaseEvent {
  event_type = 'cart_qty_change';

  constructor(
    public event_properties?: CartQtyChangeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartRemoveRes implements BaseEvent {
  event_type = 'cart_remove_res';

  constructor(
    public event_properties?: CartRemoveResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CmsLeadMagnetOptIn implements BaseEvent {
  event_type = 'cms_lead_magnet_opt_in';

  constructor(
    public event_properties?: CmsLeadMagnetOptInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CmsNotifyMeOptIn implements BaseEvent {
  event_type = 'cms_notify_me_opt_in';

  constructor(
    public event_properties?: CmsNotifyMeOptInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofAddressFilledFromEmail implements BaseEvent {
  event_type = 'cof_address_filled_from_email';

  constructor(
    public event_properties?: CofAddressFilledFromEmailProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofCodDeliveryMethodSelect implements BaseEvent {
  event_type = 'cof_cod_delivery_method_select';

  constructor(
    public event_properties?: CofCodDeliveryMethodSelectProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofCompletionAttempt implements BaseEvent {
  event_type = 'cof_completion_attempt';

  constructor(
    public event_properties?: CofCompletionAttemptProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofCompletionFailRes implements BaseEvent {
  event_type = 'cof_completion_fail_res';

  constructor(
    public event_properties?: CofCompletionFailResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofDeliveryMethodInfoOverlayOpen implements BaseEvent {
  event_type = 'cof_delivery_method_info_overlay_open';

  constructor(
    public event_properties?: CofDeliveryMethodInfoOverlayOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofDeliveryOptionSelect implements BaseEvent {
  event_type = 'cof_delivery_option_select';

  constructor(
    public event_properties?: CofDeliveryOptionSelectProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofDroppointAutoFindRes implements BaseEvent {
  event_type = 'cof_droppoint_auto_find_res';

  constructor(
    public event_properties?: CofDroppointAutoFindResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofDroppointDeliveryMethodSelect implements BaseEvent {
  event_type = 'cof_droppoint_delivery_method_select';

  constructor(
    public event_properties?: CofDroppointDeliveryMethodSelectProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofDroppointOverlayOpen implements BaseEvent {
  event_type = 'cof_droppoint_overlay_open';

  constructor(
    public event_properties?: CofDroppointOverlayOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CofPaymentOptionSelect implements BaseEvent {
  event_type = 'cof_payment_option_select';

  constructor(
    public event_properties?: CofPaymentOptionSelectProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContactEmailSentRes implements BaseEvent {
  event_type = 'contact_email_sent_res';

  constructor(
    public event_properties?: ContactEmailSentResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DataImport implements BaseEvent {
  event_type = 'data_import';

  constructor(
    public event_properties?: DataImportProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DeliveryDetailsOverlayOpen implements BaseEvent {
  event_type = 'delivery_details_overlay_open';

  constructor(
    public event_properties?: DeliveryDetailsOverlayOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ECommerceAddToCartItem implements BaseEvent {
  event_type = 'eCommerce - AddToCart - Item';

  constructor(
    public event_properties?: ECommerceAddToCartItemProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ECommerceAddToWishlistItem implements BaseEvent {
  event_type = 'eCommerce - AddToWishlist - Item';

  constructor(
    public event_properties?: ECommerceAddToWishlistItemProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ECommerceCheckout implements BaseEvent {
  event_type = 'eCommerce - Checkout';

  constructor(
    public event_properties?: ECommerceCheckoutProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ECommercePurchaseItem implements BaseEvent {
  event_type = 'eCommerce - Purchase - Item';

  constructor(
    public event_properties?: ECommercePurchaseItemProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ECommerceRemoveFromWishlistItem implements BaseEvent {
  event_type = 'eCommerce - RemoveFromWishlist - Item';

  constructor(
    public event_properties?: ECommerceRemoveFromWishlistItemProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailBounced implements BaseEvent {
  event_type = 'Email Bounced';

  constructor(
    public event_properties?: EmailBouncedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailClicked implements BaseEvent {
  event_type = 'Email Clicked';

  constructor(
    public event_properties?: EmailClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailConverted implements BaseEvent {
  event_type = 'Email Converted';

  constructor(
    public event_properties?: EmailConvertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailDelivered implements BaseEvent {
  event_type = 'Email Delivered';

  constructor(
    public event_properties?: EmailDeliveredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailFailed implements BaseEvent {
  event_type = 'Email Failed';

  constructor(
    public event_properties?: EmailFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailLinkClicked implements BaseEvent {
  event_type = 'Email Link Clicked';

  constructor(
    public event_properties?: EmailLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailOpened implements BaseEvent {
  event_type = 'Email Opened';

  constructor(
    public event_properties?: EmailOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailSent implements BaseEvent {
  event_type = 'Email Sent';

  constructor(
    public event_properties?: EmailSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailUnsubscribed implements BaseEvent {
  event_type = 'Email Unsubscribed';

  constructor(
    public event_properties?: EmailUnsubscribedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GalleryFullGalleryOpen implements BaseEvent {
  event_type = 'gallery_full_gallery_open';

  constructor(
    public event_properties?: GalleryFullGalleryOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GalleryFullGalleryZoomIn implements BaseEvent {
  event_type = 'gallery_full_gallery_zoom_in';

  constructor(
    public event_properties?: GalleryFullGalleryZoomInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GalleryThumbArrowsClick implements BaseEvent {
  event_type = 'gallery_thumb_arrows_click';

  constructor(
    public event_properties?: GalleryThumbArrowsClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GoToTop implements BaseEvent {
  event_type = 'go_to_top';

  constructor(
    public event_properties?: GoToTopProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GuidedFiltersClick implements BaseEvent {
  event_type = 'guided_filters_click';

  constructor(
    public event_properties?: GuidedFiltersClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ModalOpen implements BaseEvent {
  event_type = 'modal_open';

  constructor(
    public event_properties?: ModalOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavDesktopMegaMenuOpen implements BaseEvent {
  event_type = 'nav_desktop_mega_menu_open';

  constructor(
    public event_properties?: NavDesktopMegaMenuOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavLinkClick implements BaseEvent {
  event_type = 'nav_link_click';

  constructor(
    public event_properties?: NavLinkClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavMobileMenuCategoryToggle implements BaseEvent {
  event_type = 'nav_mobile_menu_category_toggle';

  constructor(
    public event_properties?: NavMobileMenuCategoryToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavMobileMenuThemeToggle implements BaseEvent {
  event_type = 'nav_mobile_menu_theme_toggle';

  constructor(
    public event_properties?: NavMobileMenuThemeToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavMobileMenuToggle implements BaseEvent {
  event_type = 'nav_mobile_menu_toggle';

  constructor(
    public event_properties?: NavMobileMenuToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NavSideBarCategoryToggle implements BaseEvent {
  event_type = 'nav_side_bar_category_toggle';

  constructor(
    public event_properties?: NavSideBarCategoryToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewsletterOptIn implements BaseEvent {
  event_type = 'newsletter_opt_in';

  constructor(
    public event_properties?: NewsletterOptInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewsletterOptOut implements BaseEvent {
  event_type = 'newsletter_opt_out';

  constructor(
    public event_properties?: NewsletterOptOutProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlApplyFilter implements BaseEvent {
  event_type = 'pl_apply_filter';

  constructor(
    public event_properties?: PlApplyFilterProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlApplySorting implements BaseEvent {
  event_type = 'pl_apply_sorting';

  constructor(
    public event_properties?: PlApplySortingProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostPurchaseUpsellAccept implements BaseEvent {
  event_type = 'post_purchase_upsell_accept';

  constructor(
    public event_properties: PostPurchaseUpsellAcceptProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostPurchaseUpsellDecline implements BaseEvent {
  event_type = 'post_purchase_upsell_decline';

  constructor(
    public event_properties?: PostPurchaseUpsellDeclineProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostPurchaseUpsellShow implements BaseEvent {
  event_type = 'post_purchase_upsell_show';

  constructor(
    public event_properties?: PostPurchaseUpsellShowProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PpBundleListToggle implements BaseEvent {
  event_type = 'pp_bundle_list_toggle';

  constructor(
    public event_properties?: PpBundleListToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PpCrossSalesListToggle implements BaseEvent {
  event_type = 'pp_cross_sales_list_toggle';

  constructor(
    public event_properties?: PpCrossSalesListToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PpDescriptionDesktopOpen implements BaseEvent {
  event_type = 'pp_description_desktop_open';

  constructor(
    public event_properties?: PpDescriptionDesktopOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PpDetailsMobileToggle implements BaseEvent {
  event_type = 'pp_details_mobile_toggle';

  constructor(
    public event_properties?: PpDetailsMobileToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PpGuideInfoLinkOpen implements BaseEvent {
  event_type = 'pp_guide_info_link_open';

  constructor(
    public event_properties?: PpGuideInfoLinkOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PpHcsPersonalisationAdded implements BaseEvent {
  event_type = 'pp_hcs_personalisation_added';

  constructor(
    public event_properties?: PpHcsPersonalisationAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductMissingSizeReportRes implements BaseEvent {
  event_type = 'product_missing_size_report_res';

  constructor(
    public event_properties?: ProductMissingSizeReportResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductOutOfStockOptInRes implements BaseEvent {
  event_type = 'product_out_of_stock_opt_in_res';

  constructor(
    public event_properties?: ProductOutOfStockOptInResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductReviewsOpenAll implements BaseEvent {
  event_type = 'product_reviews_open_all';

  constructor(
    public event_properties?: ProductReviewsOpenAllProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductReviewsViewMore implements BaseEvent {
  event_type = 'product_reviews_view_more';

  constructor(
    public event_properties?: ProductReviewsViewMoreProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductReviewsViewTranslated implements BaseEvent {
  event_type = 'product_reviews_view_translated';

  constructor(
    public event_properties?: ProductReviewsViewTranslatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductSizeOverlayOpen implements BaseEvent {
  event_type = 'product_size_overlay_open';

  constructor(
    public event_properties?: ProductSizeOverlayOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductSpecificationsOpen implements BaseEvent {
  event_type = 'product_specifications_open';

  constructor(
    public event_properties?: ProductSpecificationsOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PromptOpen implements BaseEvent {
  event_type = 'prompt_open';

  constructor(
    public event_properties?: PromptOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnAdditionalProductAddClick implements BaseEvent {
  event_type = 'return_additional_product_add_click';

  constructor(
    public event_properties?: ReturnAdditionalProductAddClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnAdditionalProductPreviewClick implements BaseEvent {
  event_type = 'return_additional_product_preview_click';

  constructor(
    public event_properties?: ReturnAdditionalProductPreviewClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnAdditionalProductRemoveClick implements BaseEvent {
  event_type = 'return_additional_product_remove_click';

  constructor(
    public event_properties?: ReturnAdditionalProductRemoveClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnAdditionalProductsSearchStart implements BaseEvent {
  event_type = 'return_additional_products_search_start';

  constructor(
    public event_properties?: ReturnAdditionalProductsSearchStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnBrokenEmailSent implements BaseEvent {
  event_type = 'return_broken_email_sent';

  constructor(
    public event_properties?: ReturnBrokenEmailSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnBrokenNoticeLinkClick implements BaseEvent {
  event_type = 'return_broken_notice_link_click';

  constructor(
    public event_properties?: ReturnBrokenNoticeLinkClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnBrokenNoticeShow implements BaseEvent {
  event_type = 'return_broken_notice_show';

  constructor(
    public event_properties?: ReturnBrokenNoticeShowProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnComingToStep implements BaseEvent {
  event_type = 'return_coming_to_step';

  constructor(
    public event_properties?: ReturnComingToStepProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReturnCompletionAttempt implements BaseEvent {
  event_type = 'return_completion_attempt';

  constructor(
    public event_properties?: ReturnCompletionAttemptProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RevenueAmount implements BaseEvent {
  event_type = 'revenue_amount';

  constructor(
    public event_properties?: RevenueAmountProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchStart implements BaseEvent {
  event_type = 'search_start';

  constructor(
    public event_properties?: SearchStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SessionEnd implements BaseEvent {
  event_type = 'session_end';

  constructor(
    public event_properties?: SessionEndProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SessionStart implements BaseEvent {
  event_type = 'session_start';

  constructor(
    public event_properties?: SessionStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SimpleGalleryFirstSlide implements BaseEvent {
  event_type = 'simple_gallery_first_slide';

  constructor(
    public event_properties?: SimpleGalleryFirstSlideProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SliderChangeSlide implements BaseEvent {
  event_type = 'slider_change_slide';

  constructor(
    public event_properties?: SliderChangeSlideProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SmsSent implements BaseEvent {
  event_type = 'SMS Sent';

  constructor(
    public event_properties?: SmsSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SmsCommercialOptIn implements BaseEvent {
  event_type = 'sms_commercial_opt_in';

  constructor(
    public event_properties?: SmsCommercialOptInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SmsCommercialOptOut implements BaseEvent {
  event_type = 'sms_commercial_opt_out';

  constructor(
    public event_properties?: SmsCommercialOptOutProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SuccessLetsTalkOptInRes implements BaseEvent {
  event_type = 'success_lets_talk_opt_in_res';

  constructor(
    public event_properties?: SuccessLetsTalkOptInResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SuccessOrderEmailUpdate implements BaseEvent {
  event_type = 'success_order_email_update';

  constructor(
    public event_properties?: SuccessOrderEmailUpdateProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SuccessSmsOptInRes implements BaseEvent {
  event_type = 'success_sms_opt_in_res';

  constructor(
    public event_properties?: SuccessSmsOptInResProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TimeUsedOnPage implements BaseEvent {
  event_type = 'time_used_on_page';

  constructor(
    public event_properties?: TimeUsedOnPageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TransactionalOptIn implements BaseEvent {
  event_type = 'transactional_opt_in';

  constructor(
    public event_properties?: TransactionalOptInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UnverifiedRevenue implements BaseEvent {
  event_type = 'unverified_revenue';

  constructor(
    public event_properties?: UnverifiedRevenueProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserInputError implements BaseEvent {
  event_type = 'user_input_error';

  constructor(
    public event_properties?: UserInputErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class VideoStart implements BaseEvent {
  event_type = 'video_start';

  constructor(
    public event_properties?: VideoStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPage implements BaseEvent {
  event_type = 'Viewed page';

  constructor(
    public event_properties?: ViewedPageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WishListClear implements BaseEvent {
  event_type = 'wish_list_clear';

  constructor(
    public event_properties?: WishListClearProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * [Amplitude] Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/%5BAmplitude%5D%20Page%20Viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  amplitudePageViewed(
    properties?: AmplitudePageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AmplitudePageViewed(properties), options);
  }

  /**
   * back_in_stock_subscribe
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/back_in_stock_subscribe)
   *
   * User subscribes to notifications for when items come back in stock. This happens on the product page of OOS products.
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. m_particle_source_feed)
   * @param options Amplitude event options.
   */
  backInStockSubscribe(
    properties?: BackInStockSubscribeProperties,
    options?: EventOptions,
  ) {
    return this.track(new BackInStockSubscribe(properties), options);
  }

  /**
   * ca_acc_create_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_acc_create_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caAccCreateRes(
    properties?: CaAccCreateResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaAccCreateRes(properties), options);
  }

  /**
   * ca_login_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_login_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caLoginRes(
    properties?: CaLoginResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaLoginRes(properties), options);
  }

  /**
   * ca_logout_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_logout_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caLogoutRes(
    properties?: CaLogoutResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaLogoutRes(properties), options);
  }

  /**
   * ca_my_details_update
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_my_details_update)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caMyDetailsUpdate(
    properties?: CaMyDetailsUpdateProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaMyDetailsUpdate(properties), options);
  }

  /**
   * ca_pwd_create_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_pwd_create_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caPwdCreateRes(
    properties?: CaPwdCreateResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaPwdCreateRes(properties), options);
  }

  /**
   * ca_pwd_reset_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_pwd_reset_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caPwdResetRes(
    properties?: CaPwdResetResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaPwdResetRes(properties), options);
  }

  /**
   * ca_pwd_update_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/ca_pwd_update_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  caPwdUpdateRes(
    properties?: CaPwdUpdateResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaPwdUpdateRes(properties), options);
  }

  /**
   * cart_add_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_add_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. content_percentage)
   * @param options Amplitude event options.
   */
  cartAddClick(
    properties?: CartAddClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartAddClick(properties), options);
  }

  /**
   * cart_add_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_add_failed)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cartAddFailed(
    properties?: CartAddFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartAddFailed(properties), options);
  }

  /**
   * cart_personalisation_add_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_personalisation_add_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cartPersonalisationAddClick(
    properties?: CartPersonalisationAddClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartPersonalisationAddClick(properties), options);
  }

  /**
   * cart_personalisation_update_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_personalisation_update_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cartPersonalisationUpdateClick(
    properties?: CartPersonalisationUpdateClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartPersonalisationUpdateClick(properties), options);
  }

  /**
   * cart_personalisation_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_personalisation_updated)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cartPersonalisationUpdated(
    properties?: CartPersonalisationUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartPersonalisationUpdated(properties), options);
  }

  /**
   * cart_qty_change
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_qty_change)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cartQtyChange(
    properties?: CartQtyChangeProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartQtyChange(properties), options);
  }

  /**
   * cart_remove_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cart_remove_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cartRemoveRes(
    properties?: CartRemoveResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartRemoveRes(properties), options);
  }

  /**
   * cms_lead_magnet_opt_in
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cms_lead_magnet_opt_in)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. campaign_label)
   * @param options Amplitude event options.
   */
  cmsLeadMagnetOptIn(
    properties?: CmsLeadMagnetOptInProperties,
    options?: EventOptions,
  ) {
    return this.track(new CmsLeadMagnetOptIn(properties), options);
  }

  /**
   * cms_notify_me_opt_in
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cms_notify_me_opt_in)
   *
   * User subscribes to newsletters via the "notify me" block type
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. campaign_label)
   * @param options Amplitude event options.
   */
  cmsNotifyMeOptIn(
    properties?: CmsNotifyMeOptInProperties,
    options?: EventOptions,
  ) {
    return this.track(new CmsNotifyMeOptIn(properties), options);
  }

  /**
   * cof_address_filled_from_email
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_address_filled_from_email)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofAddressFilledFromEmail(
    properties?: CofAddressFilledFromEmailProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofAddressFilledFromEmail(properties), options);
  }

  /**
   * cof_cod_delivery_method_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_cod_delivery_method_select)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofCodDeliveryMethodSelect(
    properties?: CofCodDeliveryMethodSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofCodDeliveryMethodSelect(properties), options);
  }

  /**
   * cof_completion_attempt
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_completion_attempt)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofCompletionAttempt(
    properties?: CofCompletionAttemptProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofCompletionAttempt(properties), options);
  }

  /**
   * cof_completion_fail_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_completion_fail_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofCompletionFailRes(
    properties?: CofCompletionFailResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofCompletionFailRes(properties), options);
  }

  /**
   * cof_delivery_method_info_overlay_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_delivery_method_info_overlay_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofDeliveryMethodInfoOverlayOpen(
    properties?: CofDeliveryMethodInfoOverlayOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofDeliveryMethodInfoOverlayOpen(properties), options);
  }

  /**
   * cof_delivery_option_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_delivery_option_select)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofDeliveryOptionSelect(
    properties?: CofDeliveryOptionSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofDeliveryOptionSelect(properties), options);
  }

  /**
   * cof_droppoint_auto_find_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_droppoint_auto_find_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofDroppointAutoFindRes(
    properties?: CofDroppointAutoFindResProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofDroppointAutoFindRes(properties), options);
  }

  /**
   * cof_droppoint_delivery_method_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_droppoint_delivery_method_select)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofDroppointDeliveryMethodSelect(
    properties?: CofDroppointDeliveryMethodSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofDroppointDeliveryMethodSelect(properties), options);
  }

  /**
   * cof_droppoint_overlay_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_droppoint_overlay_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofDroppointOverlayOpen(
    properties?: CofDroppointOverlayOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofDroppointOverlayOpen(properties), options);
  }

  /**
   * cof_payment_option_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/cof_payment_option_select)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  cofPaymentOptionSelect(
    properties?: CofPaymentOptionSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new CofPaymentOptionSelect(properties), options);
  }

  /**
   * contact_email_sent_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/contact_email_sent_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  contactEmailSentRes(
    properties?: ContactEmailSentResProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContactEmailSentRes(properties), options);
  }

  /**
   * data_import
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/data_import)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. m_particle_source_feed)
   * @param options Amplitude event options.
   */
  dataImport(
    properties?: DataImportProperties,
    options?: EventOptions,
  ) {
    return this.track(new DataImport(properties), options);
  }

  /**
   * delivery_details_overlay_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/delivery_details_overlay_open)
   *
   * This event tracks when a user opens the delivery details overlay, which displays information about shipping options and estimated delivery times.
   *
   *
   * The event triggers on all page types where this overlay can be shown, including when it is opened from the top-bar, product pages, or cart page.
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  deliveryDetailsOverlayOpen(
    properties?: DeliveryDetailsOverlayOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new DeliveryDetailsOverlayOpen(properties), options);
  }

  /**
   * eCommerce - AddToCart - Item
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/eCommerce%20-%20AddToCart%20-%20Item)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. applied_tactic_percentage)
   * @param options Amplitude event options.
   */
  eCommerceAddToCartItem(
    properties?: ECommerceAddToCartItemProperties,
    options?: EventOptions,
  ) {
    return this.track(new ECommerceAddToCartItem(properties), options);
  }

  /**
   * eCommerce - AddToWishlist - Item
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/eCommerce%20-%20AddToWishlist%20-%20Item)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  eCommerceAddToWishlistItem(
    properties?: ECommerceAddToWishlistItemProperties,
    options?: EventOptions,
  ) {
    return this.track(new ECommerceAddToWishlistItem(properties), options);
  }

  /**
   * eCommerce - Checkout
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/eCommerce%20-%20Checkout)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. cof_step_no)
   * @param options Amplitude event options.
   */
  eCommerceCheckout(
    properties?: ECommerceCheckoutProperties,
    options?: EventOptions,
  ) {
    return this.track(new ECommerceCheckout(properties), options);
  }

  /**
   * eCommerce - Purchase - Item
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/eCommerce%20-%20Purchase%20-%20Item)
   *
   * Item-level purchase events. Triggers once for every item in the order. This is the place to segment on item level attributes such as product category.
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. applied_tactic_percentage)
   * @param options Amplitude event options.
   */
  eCommercePurchaseItem(
    properties?: ECommercePurchaseItemProperties,
    options?: EventOptions,
  ) {
    return this.track(new ECommercePurchaseItem(properties), options);
  }

  /**
   * eCommerce - RemoveFromWishlist - Item
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/eCommerce%20-%20RemoveFromWishlist%20-%20Item)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  eCommerceRemoveFromWishlistItem(
    properties?: ECommerceRemoveFromWishlistItemProperties,
    options?: EventOptions,
  ) {
    return this.track(new ECommerceRemoveFromWishlistItem(properties), options);
  }

  /**
   * Email Bounced
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Bounced)
   *
   * From customer.io - bounces as tracked by customer.io
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailBounced(
    properties?: EmailBouncedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailBounced(properties), options);
  }

  /**
   * Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Clicked)
   *
   * From customer.io - clicks as tracked by customer.io
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailClicked(
    properties?: EmailClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailClicked(properties), options);
  }

  /**
   * Email Converted
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Converted)
   *
   * From customer.io - conversions as tracked by customer.io
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailConverted(
    properties?: EmailConvertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailConverted(properties), options);
  }

  /**
   * Email Delivered
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Delivered)
   *
   * From customer.io - successful deliveries as tracked by customer.io
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailDelivered(
    properties?: EmailDeliveredProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailDelivered(properties), options);
  }

  /**
   * Email Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Failed)
   *
   * From customer.io - when customer.io tries to send a mail but fails for any reason.
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailFailed(
    properties?: EmailFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailFailed(properties), options);
  }

  /**
   * Email Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Link%20Clicked)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailLinkClicked(
    properties?: EmailLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailLinkClicked(properties), options);
  }

  /**
   * Email Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Opened)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailOpened(
    properties?: EmailOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailOpened(properties), options);
  }

  /**
   * Email Sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Sent)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. action_id)
   * @param options Amplitude event options.
   */
  emailSent(
    properties?: EmailSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailSent(properties), options);
  }

  /**
   * Email Unsubscribed
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Email%20Unsubscribed)
   *
   * From customer.io - unsubscribes as tracked by customer.io
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. content_id)
   * @param options Amplitude event options.
   */
  emailUnsubscribed(
    properties?: EmailUnsubscribedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailUnsubscribed(properties), options);
  }

  /**
   * gallery_full_gallery_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/gallery_full_gallery_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  galleryFullGalleryOpen(
    properties?: GalleryFullGalleryOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new GalleryFullGalleryOpen(properties), options);
  }

  /**
   * gallery_full_gallery_zoom_in
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/gallery_full_gallery_zoom_in)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  galleryFullGalleryZoomIn(
    properties?: GalleryFullGalleryZoomInProperties,
    options?: EventOptions,
  ) {
    return this.track(new GalleryFullGalleryZoomIn(properties), options);
  }

  /**
   * gallery_thumb_arrows_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/gallery_thumb_arrows_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  galleryThumbArrowsClick(
    properties?: GalleryThumbArrowsClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new GalleryThumbArrowsClick(properties), options);
  }

  /**
   * go_to_top
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/go_to_top)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  goToTop(
    properties?: GoToTopProperties,
    options?: EventOptions,
  ) {
    return this.track(new GoToTop(properties), options);
  }

  /**
   * guided_filters_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/guided_filters_click)
   *
   * This event tracks when a user opens the delivery details overlay, which displays information about shipping options and estimated delivery times.
   *
   *
   * The event triggers on all page types where this overlay can be shown, including when it is opened from the top-bar, product pages, or cart page.
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  guidedFiltersClick(
    properties?: GuidedFiltersClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new GuidedFiltersClick(properties), options);
  }

  /**
   * modal_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/modal_open)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  modalOpen(
    properties?: ModalOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ModalOpen(properties), options);
  }

  /**
   * nav_desktop_mega_menu_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/nav_desktop_mega_menu_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  navDesktopMegaMenuOpen(
    properties?: NavDesktopMegaMenuOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavDesktopMegaMenuOpen(properties), options);
  }

  /**
   * nav_link_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/nav_link_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. content_percentage)
   * @param options Amplitude event options.
   */
  navLinkClick(
    properties?: NavLinkClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavLinkClick(properties), options);
  }

  /**
   * nav_mobile_menu_category_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/nav_mobile_menu_category_toggle)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. category_id)
   * @param options Amplitude event options.
   */
  navMobileMenuCategoryToggle(
    properties?: NavMobileMenuCategoryToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavMobileMenuCategoryToggle(properties), options);
  }

  /**
   * nav_mobile_menu_theme_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/nav_mobile_menu_theme_toggle)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  navMobileMenuThemeToggle(
    properties?: NavMobileMenuThemeToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavMobileMenuThemeToggle(properties), options);
  }

  /**
   * nav_mobile_menu_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/nav_mobile_menu_toggle)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  navMobileMenuToggle(
    properties?: NavMobileMenuToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavMobileMenuToggle(properties), options);
  }

  /**
   * nav_side_bar_category_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/nav_side_bar_category_toggle)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. category_id)
   * @param options Amplitude event options.
   */
  navSideBarCategoryToggle(
    properties?: NavSideBarCategoryToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavSideBarCategoryToggle(properties), options);
  }

  /**
   * newsletter_opt_in
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/newsletter_opt_in)
   *
   * User subscribes to newsletter from any source
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. campaign_label)
   * @param options Amplitude event options.
   */
  newsletterOptIn(
    properties?: NewsletterOptInProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewsletterOptIn(properties), options);
  }

  /**
   * newsletter_opt_out
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/newsletter_opt_out)
   *
   * User opts out of newsletter communications in any way
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. m_particle_source_feed)
   * @param options Amplitude event options.
   */
  newsletterOptOut(
    properties?: NewsletterOptOutProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewsletterOptOut(properties), options);
  }

  /**
   * pl_apply_filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pl_apply_filter)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  plApplyFilter(
    properties?: PlApplyFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlApplyFilter(properties), options);
  }

  /**
   * pl_apply_sorting
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pl_apply_sorting)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  plApplySorting(
    properties?: PlApplySortingProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlApplySorting(properties), options);
  }

  /**
   * post_purchase_upsell_accept
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/post_purchase_upsell_accept)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  postPurchaseUpsellAccept(
    properties: PostPurchaseUpsellAcceptProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostPurchaseUpsellAccept(properties), options);
  }

  /**
   * post_purchase_upsell_decline
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/post_purchase_upsell_decline)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  postPurchaseUpsellDecline(
    properties?: PostPurchaseUpsellDeclineProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostPurchaseUpsellDecline(properties), options);
  }

  /**
   * post_purchase_upsell_show
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/post_purchase_upsell_show)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  postPurchaseUpsellShow(
    properties?: PostPurchaseUpsellShowProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostPurchaseUpsellShow(properties), options);
  }

  /**
   * pp_bundle_list_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pp_bundle_list_toggle)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  ppBundleListToggle(
    properties?: PpBundleListToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new PpBundleListToggle(properties), options);
  }

  /**
   * pp_cross_sales_list_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pp_cross_sales_list_toggle)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  ppCrossSalesListToggle(
    properties?: PpCrossSalesListToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new PpCrossSalesListToggle(properties), options);
  }

  /**
   * pp_description_desktop_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pp_description_desktop_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  ppDescriptionDesktopOpen(
    properties?: PpDescriptionDesktopOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new PpDescriptionDesktopOpen(properties), options);
  }

  /**
   * pp_details_mobile_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pp_details_mobile_toggle)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  ppDetailsMobileToggle(
    properties?: PpDetailsMobileToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new PpDetailsMobileToggle(properties), options);
  }

  /**
   * pp_guide_info_link_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pp_guide_info_link_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  ppGuideInfoLinkOpen(
    properties?: PpGuideInfoLinkOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new PpGuideInfoLinkOpen(properties), options);
  }

  /**
   * pp_hcs_personalisation_added
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/pp_hcs_personalisation_added)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  ppHcsPersonalisationAdded(
    properties?: PpHcsPersonalisationAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PpHcsPersonalisationAdded(properties), options);
  }

  /**
   * product_missing_size_report_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_missing_size_report_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  productMissingSizeReportRes(
    properties?: ProductMissingSizeReportResProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductMissingSizeReportRes(properties), options);
  }

  /**
   * product_out_of_stock_opt_in_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_out_of_stock_opt_in_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  productOutOfStockOptInRes(
    properties?: ProductOutOfStockOptInResProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductOutOfStockOptInRes(properties), options);
  }

  /**
   * product_reviews_open_all
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_reviews_open_all)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  productReviewsOpenAll(
    properties?: ProductReviewsOpenAllProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductReviewsOpenAll(properties), options);
  }

  /**
   * product_reviews_view_more
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_reviews_view_more)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  productReviewsViewMore(
    properties?: ProductReviewsViewMoreProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductReviewsViewMore(properties), options);
  }

  /**
   * product_reviews_view_translated
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_reviews_view_translated)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  productReviewsViewTranslated(
    properties?: ProductReviewsViewTranslatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductReviewsViewTranslated(properties), options);
  }

  /**
   * product_size_overlay_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_size_overlay_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  productSizeOverlayOpen(
    properties?: ProductSizeOverlayOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductSizeOverlayOpen(properties), options);
  }

  /**
   * product_specifications_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/product_specifications_open)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. block_id)
   * @param options Amplitude event options.
   */
  productSpecificationsOpen(
    properties?: ProductSpecificationsOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductSpecificationsOpen(properties), options);
  }

  /**
   * prompt_open
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/prompt_open)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. content_percentage)
   * @param options Amplitude event options.
   */
  promptOpen(
    properties?: PromptOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new PromptOpen(properties), options);
  }

  /**
   * return_additional_product_add_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_additional_product_add_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnAdditionalProductAddClick(
    properties?: ReturnAdditionalProductAddClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnAdditionalProductAddClick(properties), options);
  }

  /**
   * return_additional_product_preview_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_additional_product_preview_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnAdditionalProductPreviewClick(
    properties?: ReturnAdditionalProductPreviewClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnAdditionalProductPreviewClick(properties), options);
  }

  /**
   * return_additional_product_remove_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_additional_product_remove_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnAdditionalProductRemoveClick(
    properties?: ReturnAdditionalProductRemoveClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnAdditionalProductRemoveClick(properties), options);
  }

  /**
   * return_additional_products_search_start
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_additional_products_search_start)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnAdditionalProductsSearchStart(
    properties?: ReturnAdditionalProductsSearchStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnAdditionalProductsSearchStart(properties), options);
  }

  /**
   * return_broken_email_sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_broken_email_sent)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnBrokenEmailSent(
    properties?: ReturnBrokenEmailSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnBrokenEmailSent(properties), options);
  }

  /**
   * return_broken_notice_link_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_broken_notice_link_click)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnBrokenNoticeLinkClick(
    properties?: ReturnBrokenNoticeLinkClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnBrokenNoticeLinkClick(properties), options);
  }

  /**
   * return_broken_notice_show
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_broken_notice_show)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnBrokenNoticeShow(
    properties?: ReturnBrokenNoticeShowProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnBrokenNoticeShow(properties), options);
  }

  /**
   * return_coming_to_step
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_coming_to_step)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnComingToStep(
    properties?: ReturnComingToStepProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnComingToStep(properties), options);
  }

  /**
   * return_completion_attempt
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/return_completion_attempt)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  returnCompletionAttempt(
    properties?: ReturnCompletionAttemptProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReturnCompletionAttempt(properties), options);
  }

  /**
   * revenue_amount
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/revenue_amount)
   *
   * Main revenue event - order level.
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. $price)
   * @param options Amplitude event options.
   */
  revenueAmount(
    properties?: RevenueAmountProperties,
    options?: EventOptions,
  ) {
    return this.track(new RevenueAmount(properties), options);
  }

  /**
   * search_start
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/search_start)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  searchStart(
    properties?: SearchStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchStart(properties), options);
  }

  /**
   * session_end
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/session_end)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  sessionEnd(
    properties?: SessionEndProperties,
    options?: EventOptions,
  ) {
    return this.track(new SessionEnd(properties), options);
  }

  /**
   * session_start
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/session_start)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  sessionStart(
    properties?: SessionStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new SessionStart(properties), options);
  }

  /**
   * simple_gallery_first_slide
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/simple_gallery_first_slide)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  simpleGalleryFirstSlide(
    properties?: SimpleGalleryFirstSlideProperties,
    options?: EventOptions,
  ) {
    return this.track(new SimpleGalleryFirstSlide(properties), options);
  }

  /**
   * slider_change_slide
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/slider_change_slide)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  sliderChangeSlide(
    properties?: SliderChangeSlideProperties,
    options?: EventOptions,
  ) {
    return this.track(new SliderChangeSlide(properties), options);
  }

  /**
   * SMS Sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/SMS%20Sent)
   *
   * From customer.io - sms sends as reported by customer.io
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. content_id)
   * @param options Amplitude event options.
   */
  smsSent(
    properties?: SmsSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new SmsSent(properties), options);
  }

  /**
   * sms_commercial_opt_in
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/sms_commercial_opt_in)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. m_particle_source_feed)
   * @param options Amplitude event options.
   */
  smsCommercialOptIn(
    properties?: SmsCommercialOptInProperties,
    options?: EventOptions,
  ) {
    return this.track(new SmsCommercialOptIn(properties), options);
  }

  /**
   * sms_commercial_opt_out
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/sms_commercial_opt_out)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. m_particle_source_feed)
   * @param options Amplitude event options.
   */
  smsCommercialOptOut(
    properties?: SmsCommercialOptOutProperties,
    options?: EventOptions,
  ) {
    return this.track(new SmsCommercialOptOut(properties), options);
  }

  /**
   * success_lets_talk_opt_in_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/success_lets_talk_opt_in_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  successLetsTalkOptInRes(
    properties?: SuccessLetsTalkOptInResProperties,
    options?: EventOptions,
  ) {
    return this.track(new SuccessLetsTalkOptInRes(properties), options);
  }

  /**
   * success_order_email_update
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/success_order_email_update)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  successOrderEmailUpdate(
    properties?: SuccessOrderEmailUpdateProperties,
    options?: EventOptions,
  ) {
    return this.track(new SuccessOrderEmailUpdate(properties), options);
  }

  /**
   * success_sms_opt_in_res
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/success_sms_opt_in_res)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  successSmsOptInRes(
    properties?: SuccessSmsOptInResProperties,
    options?: EventOptions,
  ) {
    return this.track(new SuccessSmsOptInRes(properties), options);
  }

  /**
   * time_used_on_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/time_used_on_page)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  timeUsedOnPage(
    properties?: TimeUsedOnPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new TimeUsedOnPage(properties), options);
  }

  /**
   * transactional_opt_in
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/transactional_opt_in)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. m_particle_source_feed)
   * @param options Amplitude event options.
   */
  transactionalOptIn(
    properties?: TransactionalOptInProperties,
    options?: EventOptions,
  ) {
    return this.track(new TransactionalOptIn(properties), options);
  }

  /**
   * unverified_revenue
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/unverified_revenue)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. $price)
   * @param options Amplitude event options.
   */
  unverifiedRevenue(
    properties?: UnverifiedRevenueProperties,
    options?: EventOptions,
  ) {
    return this.track(new UnverifiedRevenue(properties), options);
  }

  /**
   * user_input_error
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/user_input_error)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  userInputError(
    properties?: UserInputErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserInputError(properties), options);
  }

  /**
   * video_start
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/video_start)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  videoStart(
    properties?: VideoStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoStart(properties), options);
  }

  /**
   * Viewed page
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/Viewed%20page)
   *
   * This event tracks when a user views any page on our website, once every time a page is loaded.
   *
   * Owner: Severi
   *
   * @param properties The event's properties (e.g. attribute_sub_type)
   * @param options Amplitude event options.
   */
  viewedPage(
    properties?: ViewedPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPage(properties), options);
  }

  /**
   * wish_list_clear
   *
   * [View in Tracking Plan](https://data.amplitude.com/trendhim/Trendhim%20-%20Prod-1/events/main/latest/wish_list_clear)
   *
   * Owner: Bjørn Seaton
   *
   * @param properties The event's properties (e.g. country)
   * @param options Amplitude event options.
   */
  wishListClear(
    properties?: WishListClearProperties,
    options?: EventOptions,
  ) {
    return this.track(new WishListClear(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
